"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioGroup = require("../RadioGroup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function BooleanInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;
  return /*#__PURE__*/_react["default"].createElement(_RadioGroup.RadioGroup, {
    value: value,
    options: [{
      valueField: 'True',
      textField: 'True'
    }, {
      valueField: 'False',
      textField: 'False'
    }],
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  });
}

BooleanInput.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].string.isRequired
};
var _default = BooleanInput;
exports["default"] = _default;